import { render, staticRenderFns } from "./yongjing.vue?vue&type=template&id=45822986&scoped=true&"
import script from "./yongjing.vue?vue&type=script&lang=js&"
export * from "./yongjing.vue?vue&type=script&lang=js&"
import style0 from "./yongjing.vue?vue&type=style&index=0&id=45822986&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45822986",
  null
  
)

export default component.exports